import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IntroTemplate from '../../components/IntroTemplate/IntroTemplate'; // Adjust the path as per your project structure
import SmallDescription from "../../components/SmallDescription/SmallDescription";
import FootprintStats from "../../components/FootprintStats/FootprintStats";
import ProjectImageScroll from '../../components/ProjectImageScroll/ProjectImageScroll';
import RedirectToPage from '../../components/RedirectToPage/RedirectToPage'; // Adjust the path
import ViewSlider from '../../components/ViewSlider/ViewSlider';
import KeyPoints from '../../components/KeyPoints/KeyPoints';

const ProjectPage = () => {
  const { id } = useParams(); // Get the project ID from the URL
  const data = getStoredData()?.["4"] ?? {};
  const View = getStoredData()?.["13"] ?? {};
  const [project, setProject] = useState(null); // State to store project details
  const [error, setError] = useState(null); // State for handling errors

  const [products, setProducts] = useState([]); // State for all products

useEffect(() => {
  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/products');
      setProducts(response.data);
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  };

  fetchProducts();
}, []);


  useEffect(() => {
    // Fetch project details using the ID from the URL
    const fetchProject = async () => {
      try {
        const response = await axios.get(`https://shahbad-enterprises-backend.vercel.app/projects/${id}`);
        setProject(response.data);
      } catch (err) {
        console.error('Error fetching project details:', err);
        setError('Failed to fetch project details.');
      }
    };

    if (id) {
      fetchProject();
    }
  }, [id]);

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  if (!project) {
    return <div>Loading project details...</div>; // Display loading message while fetching data
  }

  return (
    <div>
      <IntroTemplate 
        logo={project.icon} 
        title={project.title} 
        image={project.photo?.[0]?.url} 
      />
      <SmallDescription title={project.projectsname} details={project.details}/>
      <KeyPoints points={project.keypoints}  title={View.KeyPointsTitle}/>
      <ProjectImageScroll data={project.photo} title={View.imageHeading} detail={View.imageDetails}/>
      {/* <FootprintStats 
        stats={project.stats} 
      /> */}
      <ViewSlider
        title={View.HomeBlogTitle}
        link={View.HomeBlogLink}
        text={View.HomeBlogText}
        items={products}
      />
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText}
      />
    </div>
  );
};

export default ProjectPage;
